import React from "react"

import { useLoaderData } from "react-router-dom"

import { MainHeading } from "../MainHeading"

//region Types
export type InventoryShowProps = {}
//endregion

//region Component
export function InventoryShow() {
  const data = useLoaderData<InventoryShowProps>()

  //region Event Handlers
  //endregion

  //region JSX
  return <MainHeading title="Inventory" description="Inventory goes here" />
  //endregion
}
//endregion

//region Private
//endregion
